/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";


/* Helpers, constants, custom methods, internal libraries */
import { useTravelerService } from "../../../services/travelerService";

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as UnitedAirlinesIconSvg } from '../../../resources/images/united-airlines-icon.svg';

/* Styles */
import styles from "./styles";

const JoinUnitedAirlinesProgramModal = ({ showModal, setShowModal, unitedAirlinesSupplier, joinUnitedAirlines }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const { travelerDetails } = useTravelerService();

  return (
    <UCModal
      className={classes.joinUnitedAirlinesProgramModalModal}
      showModal={showModal}
      setShowModal={setShowModal}
      modalIcon={<UnitedAirlinesIconSvg />}
      modalTitle={<FormattedMessage id="airlineProgram.unitedAirlines.modal.title" />}
      modalDescription={<FormattedMessage id="airlineProgram.unitedAirlines.modal.description" />}
      modalContent={
        <Content 
          setShowModal={setShowModal} 
          unitedAirlinesSupplier={unitedAirlinesSupplier} 
          joinUnitedAirlines={joinUnitedAirlines}
          travelerDetails={travelerDetails}
        />
      }
      dataTestId="joinUnitedAirlinesProgramModalModal"
    />
  )
}

export default JoinUnitedAirlinesProgramModal;
